import { actionHandler } from "../api";

const InitialRegUrl = `/api/method/guidestar.api.npo_registration.make_initial_registration`;
const SubQuestionsUrl = `/api/method/guidestar.api.npo_registration.make_sub_question_answers`;
const SubmitDiscoverPanUrl = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_1`;
const SubmitDiscoverLegalMainUrl = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_2`;
const submitEOIUrl = `/api/method/guidestar.api.expression_of_interest.make_expression_of_interest`;
const submitHeadOfOrganizationUrl = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_3`;
const ContactPersonOfOrganizationUrl = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_4`;
const Section5Url = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_5`;
const Section6Url = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_6`;
const Section7Url = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_7`;
const Section8Url = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_8`;
const Section9Url = `/api/method/guidestar.api.npo_registration.make_discover_registration_section_9`;
const engageSection1Url = `/api/method/guidestar.api.npo_registration.make_engage_registration_section_1`;
const engageSection2Url = `/api/method/guidestar.api.npo_registration.make_engage_registration_section_2`;
const engageSection3Url = `/api/method/guidestar.api.npo_registration.make_engage_registration_section_3`;
const engageSection4Url = `/api/method/guidestar.api.npo_registration.make_engage_registration_section_4`;
const engageSection5Url = `/api/method/guidestar.api.npo_registration.make_engage_registration_section_5`;
const engageSection6Url = `/api/method/guidestar.api.npo_registration.make_engage_registration_section_6`;
const bronzeSection1Url = `/api/method/guidestar.api.bronze_level.make_bronze_questions_section_1`;
const bronzeSection2Url = `/api/method/guidestar.api.bronze_level.make_bronze_questions_section_2`;
const bronzeSection3Url = `/api/method/guidestar.api.bronze_level.make_bronze_questions_section_3`;
const bronzeSectionSubUrl = `/api/method/guidestar.api.bronze_level.make_bronze_sub_question_answers`;
const submitContributionUrl = `api/method/guidestar.api.contribution.make_contribution`;
const TargetSegmentUrl = `/api/method/guidestar.api.pillar_1.make_target_segment_question_answers`;
const TargetSegmentSubUrl = `api/method/guidestar.api.pillar_1.make_pillar_1_sub_question_answers`;
const HistoryUrl = `/api/method/guidestar.api.pillar_1.make_history_question_answers`;
const VisionUrl = `/api/method/guidestar.api.pillar_2.make_vision_question_answers`;
const StrategyUrl = `/api/method/guidestar.api.pillar_2.make_strategy_and_goals_question_answers`;
const UndertakingUrl = `api/method/guidestar.api.undertaking.make_undertaking_question_answers`;
const UndertakingSubUrl = `api/method/guidestar.api.undertaking.make_undertaking_sub_question_answers`;
const TopProgrammesUrl = `api/method/guidestar.api.activities_and_programmes.make_top_programmes_question_answers`;
const riskSection1Url = `/api/method/guidestar.api.pillar_3.make_risk_resilience_question_answers`;
const riskSection2Url = `/api/method/guidestar.api.pillar_3.make_prevention_of_risk_question_answers`;
const riskSection3Url = `/api/method/guidestar.api.pillar_3.make_organisational_resilence_question_answers`;
const riskSection4Url = `/api/method/guidestar.api.pillar_3.make_external_references_question_answers`;
const operationSection1Url = `/api/method/guidestar.api.pillar_4.make_staff_distribution_question_answers`;
const operationSection1SubUrl = `/api/method/guidestar.api.pillar_4.make_staff_distribution_sub_question_answers`;
const MonthlyCompensation1Url = `/api/method/guidestar.api.pillar_4.make_monthly_compensation_question_answers`;
const operationSection2Url = `/api/method/guidestar.api.pillar_4.make_people_engaged_question_answers`;
const operationSection3Url = `/api/method/guidestar.api.pillar_4.make_operations_planning_and_management_question_answers`;
const operationSection4Url = `/api/method/guidestar.api.pillar_4.make_collaborations_question_answers`;
const TopProgrammesSubUrl = `/api/method/guidestar.api.activities_and_programmes.make_top_programmes_sub_question_answers`;
const SourcesOfFundingUrl = `/api/method/guidestar.api.pillar_3.make_sources_of_funding_question_answers`;
const SourcesOfFundingSubUrl = `/api/method/guidestar.api.pillar_3.make_pillar_3_sub_question_answers`;
const ProgrammeDetailsUrl = `api/method/guidestar.api.pillar_3.make_programme_details_question_answers`;
const TopDonorsUrl = `api/method/guidestar.api.top_donors.make_top_donors_question_answers`;
const TopDonorsSubUrl = `api/method/guidestar.api.top_donors.make_top_donors_sub_question_answers`;
const financeSection1Url = `/api/method/guidestar.api.pillar_4.make_balance_sheet_question_answers`;
const financeSection2Url = `/api/method/guidestar.api.pillar_4.make_receipts_payments_question_answers`;
const financeSection3Url = `/api/method/guidestar.api.pillar_4.make_income_expenditure_question_answers`;
const financeSection4Url = `/api/method/guidestar.api.pillar_4.make_auditor_account_question_answers`;
const financeSection5Url = `/api/method/guidestar.api.pillar_4.make_bank_account_details_question_answers`;
const financeSection6Url = `/api/method/guidestar.api.pillar_4.make_accounting_practices_question_answers`;
const financeSection7Url = `/api/method/guidestar.api.pillar_4.make_financial_reporting_to_funders_question_answers`;
const financeSection8Url = `/api/method/guidestar.api.pillar_4.make_receipts_income_question_answers`;
const financeSection9Url = `/api/method/guidestar.api.pillar_4.make_payments_expenditure_question_answers`;
const financeSection10Url = `/api/method/guidestar.api.pillar_4.make_assets_question_answers`;
const financeSection11Url = `/api/method/guidestar.api.pillar_4.make_liabilities_question_answers`;
const needsAndAsk1Url = `/api/method/guidestar.api.needs_or_asks.make_needs_or_asks_question_answers`;
const PeopleEngageBasedOnNature1Url = `/api/method/guidestar.api.pillar_4.make_people_engaged_based_on_nature_question_answers`;
const PeopleEngageBasedOnNature1SubUrl = `/api/method/guidestar.api.pillar_4.make_people_engaged_based_on_nature_sub_question_answers`;
const PeopleEngagedBasedOnDiversity1Url = `/api/method/guidestar.api.pillar_4.make_people_engaged_based_on_diversity_question_answers`;
const PeopleEngagedBasedOnDiversity1SubUrl = `/api/method/guidestar.api.pillar_4.make_people_engaged_based_on_diversity_question_answers`;
const DataPrivacy1Url = `/api/method/guidestar.api.pillar_4.make_data_privacy_question_answers`;
const Capabilities1Url = `/api/method/guidestar.api.pillar_7.make_capabilities_question_answers`;
const Challenges1Url = `/api/method/guidestar.api.pillar_7.make_challenges_question_answers`;
const GoverningBodyMemberDetails1Url = `/api/method/guidestar.api.governance.make_governing_body_member_question_answers`;
const GoverningBodyMemberDetailsSub1Url = `/api/method/guidestar.api.governance.make_governing_body_member_sub_question_answers`;
const FunctioningOfTheBoard1Url = `/api/method/guidestar.api.pillar_5.make_functioning_of_the_board_question_answers`;
const GoodGovernancePractices1Url = `/api/method/guidestar.api.pillar_5.make_good_governance_practices_question_answers`;
const SocialImpact1Url = `/api/method/guidestar.api.pillar_6.make_social_impact_question_answers`;
const Accountability1Url = `/api/method/guidestar.api.pillar_5.make_accountability_question_answers`;
const ComplianceSubUrl = `api/method/guidestar.api.bronze_level.make_bronze_sub_question_answers`;
const InternalComplianceUrl = `api/method/guidestar.api.pillar_4.make_internal_compliance_question_answers`;
const CompliancePrimaryUrl = `api/method/guidestar.api.pillar_4.make_compliance_with_primary_regulatory_authority_question_answers`;
const ComplianceIncomeUrl = `api/method/guidestar.api.pillar_4.make_compliance_with_income_tax_question_answers`;
const ComplianceFCRAUrl = `api/method/guidestar.api.pillar_4.make_compliance_with_fcra_question_answers`;
const ComplianceStakeholdersUrl = `api/method/guidestar.api.pillar_4.make_compliance_with_stakeholders_question_answers`;
const editRegistrationUrl = `/api/method/guidestar.api.npo_profile_edit_request.make_npo_profile_edit_request`;

// get apis

const initialRegQ = `/api/method/guidestar.api.npo_registration.get_initial_registration_questions`;
const panDiscoverQ = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_1_questions`;
const legalDiscoverQ = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_2_questions`;
const HeadOfOrganizationQ = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_3_questions`;
const ContactPersonOfOrganizationQ = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_4_questions`;
const Section5Q = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_5_questions`;
const Section6Q = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_6_questions`;
const Section7Q = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_7_questions`;
const Section8Q = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_8_questions`;
const Section9Q = `/api/method/guidestar.api.npo_registration.get_discover_registration_section_9_questions`;
const engageSection1Q = `/api/method/guidestar.api.npo_registration.get_engage_registration_section_1`;
const engageSection2Q = `/api/method/guidestar.api.npo_registration.get_engage_registration_section_2`;
const engageSection3Q = `/api/method/guidestar.api.npo_registration.get_engage_registration_section_3`;
const engageSection4Q = `/api/method/guidestar.api.npo_registration.get_engage_registration_section_4`;
const engageSection5Q = `/api/method/guidestar.api.npo_registration.get_engage_registration_section_5`;
const engageSection6Q = `/api/method/guidestar.api.npo_registration.get_engage_registration_section_6`;
const targetSegmentQ = `api/method/guidestar.api.pillar_1.get_target_segment_question_answers`;
const historyQ = `api/method/guidestar.api.pillar_1.get_history_question_answers`;
const visionQ = `api/method/guidestar.api.pillar_2.get_vision_question_answers`;
const strategyQ = `api/method/guidestar.api.pillar_2.get_strategy_and_goals_question_answers`;
const bronzeSectionGsn = `/api/method/guidestar.api.bronze_level.get_gsn_number`;
const bronzeSection1Q = `/api/method/guidestar.api.bronze_level.get_bronze_questions_section_1_questions`;
const bronzeSection2Q = `/api/method/guidestar.api.bronze_level.get_bronze_questions_section_2_questions`;
const bronzeSection3Q = `/api/method/guidestar.api.bronze_level.get_bronze_questions_section_3_questions`;
const riskSection1Q = `/api/method/guidestar.api.pillar_3.get_risk_resilience_question_answers`;
const riskSection2Q = `/api/method/guidestar.api.pillar_3.get_prevention_of_risk_question_answers`;
const riskSection3Q = `/api/method/guidestar.api.pillar_3.get_organisational_resilence_question_answers`;
const riskSection4Q = `/api/method/guidestar.api.pillar_3.get_external_references_question_answers`;
const operationSection1Q = `/api/method/guidestar.api.pillar_4.get_staff_distribution_question_answers`;
const MonthlyCompensationQ = `/api/method/guidestar.api.pillar_4.get_monthly_compensation_question_answers`;
const operationSection2Q = `/api/method/guidestar.api.pillar_4.get_people_engaged_question_answers`;
const operationSection3Q = `/api/method/guidestar.api.pillar_4.get_operations_planning_and_management_question_answers`;
const operationSection4Q = `/api/method/guidestar.api.pillar_4.get_collaborations_question_answers`;
const financeSection1Q = `/api/method/guidestar.api.pillar_4.get_balance_sheet_question_answers`;
const financeSection2Q = `/api/method/guidestar.api.pillar_4.get_receipts_payments_question_answers`;
const financeSection3Q = `/api/method/guidestar.api.pillar_4.get_income_expenditure_question_answers`;
const financeSection4Q = `/api/method/guidestar.api.pillar_4.get_auditor_account_question_answers`;
const financeSection5Q = `/api/method/guidestar.api.pillar_4.get_bank_account_details_question_answers`;
const financeSection6Q = `/api/method/guidestar.api.pillar_4.get_accounting_practices_question_answers`;
const financeSection7Q = `/api/method/guidestar.api.pillar_4.get_financial_reporting_to_funders_question_answers`;
const financeSection8Q = `/api/method/guidestar.api.pillar_4.get_receipts_income_question_answers`;
const financeSection9Q = `/api/method/guidestar.api.pillar_4.get_payments_expenditure_question_answers`;
const financeSection10Q = `/api/method/guidestar.api.pillar_4.get_assets_question_answers`;
const financeSection11Q = `/api/method/guidestar.api.pillar_4.get_liabilities_question_answers`;
const needsAndAsk1Q = `/api/method/guidestar.api.needs_or_asks.get_needs_or_asks_question_answers`;
const PeopleEngageBasedOnNature1Q = `/api/method/guidestar.api.pillar_4.get_people_engaged_based_on_nature_question_answers`;
const PeopleEngagedBasedOnDiversity1Q = `/api/method/guidestar.api.pillar_4.get_people_engaged_based_on_diversity_question_answers`;
const participationInResearcQ = `/api/method/guidestar.api.participation_in_research.get_participation_in_research`;
const DataPrivacy1Q = `/api/method/guidestar.api.pillar_4.get_data_privacy_question_answers`;
const Challenges1Q = `/api/method/guidestar.api.pillar_7.get_challenges_question_answers`;
const Capabilities1Q = `/api/method/guidestar.api.pillar_7.get_capabilities_question_answers`;
const Accountability1Q = `/api/method/guidestar.api.pillar_5.get_accountability_question_answers`;
const showBronzeApi = `/api/method/guidestar.api.bronze_level.get_expression_of_interest`;
const undertakingQ = `api/method/guidestar.api.undertaking.get_undertaking_question_answers`;
const TopProgrammesQ = `api/method/guidestar.api.activities_and_programmes.get_top_programmes_question_answers`;
const EOIQ = `api/method/guidestar.api.expression_of_interest.get_expression_of_interest_data`;
const ContributionQ = `api/method/guidestar.api.contribution.get_contribution_data`;
const SourcesOfFundingQ = `api/method/guidestar.api.pillar_3.get_sources_of_funding_question_answers`;
const ProgrammeDetailsQ = `api/method/guidestar.api.pillar_3.get_programme_details_question_answers`;
const TopDonorsQ = `api/method/guidestar.api.top_donors.get_top_donors_question_answers`;
const MissionQ = `api/method/guidestar.api.pillar_2.get_mission_description`;
const GoverningBodyMemberDetails1Q = `/api/method/guidestar.api.governance.get_governing_body_member_question_answers`;
const FunctioningOfTheBoard1Q = `/api/method/guidestar.api.pillar_5.get_functioning_of_the_board_question_answers`;
const GoodGovernancePractices1Q = `/api/method/guidestar.api.pillar_5.get_good_governance_practices_question_answers`;
const SocialImpact1Q = `/api/method/guidestar.api.pillar_6.get_social_impact_question_answers`;
const InternalComplianceQ = `api/method/guidestar.api.pillar_4.get_internal_compliance_question_answers`;
const CompliancePrimaryQ = `api/method/guidestar.api.pillar_4.get_compliance_with_primary_regulatory_authority_question_answers`;
const ComplianceIncomeQ = `api/method/guidestar.api.pillar_4.get_compliance_with_income_tax_question_answers`;
const ComplianceFCRAQ = `api/method/guidestar.api.pillar_4.get_compliance_with_fcra_question_answers`;
const ComplianceStakeholdersQ = `api/method/guidestar.api.pillar_4.get_compliance_with_stakeholders_question_answers`;
const WorkshopAttendedQ = `api/method/guidestar.api.workshops_attended.get_workshops_attended`;

// initial registration api calls
export const initialLoading = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };
    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${initialRegQ}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const initialRegistration = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: InitialRegUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const initialSubRegistration = async (payload) => {
  try {
    console.log("payload>>>",payload)
    const { data } = await actionHandler({
      url: payload?.args?.gsn_num ? bronzeSectionSubUrl : SubQuestionsUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const editRegistration = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: editRegistrationUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// discover pan api calls

export const discoveryInitialQ = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);

    const { data } = await actionHandler({
      url: `${panDiscoverQ}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const discoverPanRegCall = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: SubmitDiscoverPanUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// discover legal api calls

export const discoveryLegalQ = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);

    const { data } = await actionHandler({
      url: `${legalDiscoverQ}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const discoveryLegalMainSubmit = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: SubmitDiscoverLegalMainUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const discoveryLegalSubSubmit = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: SubQuestionsUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// EOI registration Api Call

export const ExpressionOfInterestRegistration = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: submitEOIUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Contribution registration Api Call

export const ContributionRegistration = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: submitContributionUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// HeadOfOrganization api

export const HeadOfOrganizationGet = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);

    const { data } = await actionHandler({
      url: `${HeadOfOrganizationQ}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const HeadOfOrganizationPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: submitHeadOfOrganizationUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// ContactPersonOfOrganization api

export const ContactPersonOfOrganizationGet = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);

    const { data } = await actionHandler({
      url: `${ContactPersonOfOrganizationQ}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const ContactPersonOfOrganizationPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: ContactPersonOfOrganizationUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// discover Section5 api

export const Section5Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Section5Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const Section5Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Section5Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// discover Section6 api

export const Section6Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Section6Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const Section6Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Section6Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// discover Section7 api

export const Section7Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Section7Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const Section7Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Section7Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// discover Section8 api

export const Section8Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Section8Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const Section8Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Section8Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// discover Section9 api

export const Section9Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Section9Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const Section9Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Section9Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// Engage engage section 1 api

export const EngageSection1Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${engageSection1Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const EngageSection1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: engageSection1Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// Engage engage section 2 api

export const EngageSection2Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${engageSection2Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const EngageSection2Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: engageSection2Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// Engage engage section 3 api

export const EngageSection3Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${engageSection3Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const EngageSection3Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: engageSection3Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// Engage engage section 4 api

export const EngageSection4Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${engageSection4Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const EngageSection4Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: engageSection4Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// Engage engage section 5 api

export const EngageSection5Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${engageSection5Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const EngageSection5Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: engageSection5Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
// Engage engage section 5 api

export const EngageSection6Get = async (db, key) => {
  try {
    const setApplication_no = {
      application_no: `${key ? key : ""}`,
      db_name: db ? db : "",
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${engageSection6Q}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const EngageSection6Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: engageSection6Url,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Target Segment api

export const TargetSegmentGet = async (key) => {
  try {
    if (key) {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${targetSegmentQ}?args=${args}`,
        method: "GET",
      });
      return data;
    }
  } catch (error) {
    throw error;
  }
};
export const BronzeSectionGsnGet = async (number, dataBase) => {
  try {
    const setApplication_no = {
      application_no: `${number}`,
      db_name: dataBase,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);

    // Log the URL for debugging

    // Correctly format the URL with the JSON string encoded
    const { data } = await actionHandler({
      url: `${bronzeSectionGsn}?args=${args}`,
      method: "GET",
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const BronzeSection1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: bronzeSection1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const BronzeSection1Get = async (key) => {
  if (key) {
    try {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${bronzeSection1Q}?args=${args}`,
        method: "GET",
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
};
export const BronzeSectionSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: bronzeSectionSubUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// Bronze engage section 1 api
export const BronzeSection2Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${bronzeSection2Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const BronzeSection2Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: bronzeSection2Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// Bronze  section 1 api
export const BronzeSection3Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${bronzeSection3Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const BronzeSection3Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: bronzeSection3Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ShowBronze = async (key) => {
  try {
    if (key) {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${showBronzeApi}?args=${args}`,
        method: "GET",
      });
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const TargetSegmentPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: TargetSegmentUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const TargetSegmentSubQPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: TargetSegmentSubUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// History api

export const HistoryGet = async (key) => {
  try {
    if (key) {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${historyQ}?args=${args}`,
        method: "GET",
      });
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const HistoryPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: HistoryUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Vision api

export const VisionGet = async (key) => {
  try {
    if (key) {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${visionQ}?args=${args}`,
        method: "GET",
      });
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const VisionPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: VisionUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Strategy and Goal api

export const StrategyAndGoalGet = async (key) => {
  try {
    if (key) {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${strategyQ}?args=${args}`,
        method: "GET",
      });
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const StrategyAndGoalPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: StrategyUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Undertaking api

export const UndertakingGet = async (key) => {
  try {
    if (key) {
      const setApplication_no = {
        gsn_no: `${key ? key : ""}`,
      };

      // Convert the args object to a JSON string and encode it for use in a URL
      const args = JSON.stringify(setApplication_no);
      const { data } = await actionHandler({
        url: `${undertakingQ}?args=${args}`,
        method: "GET",
      });
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const UndertakingPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: UndertakingUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const UndertakingSubQPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: UndertakingSubUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Top Programmes api

export const TopProgrammesGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${TopProgrammesQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const TopProgrammesPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: TopProgrammesUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};
export const TopProgrammesSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: TopProgrammesSubUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const EOIGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${EOIQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ContributionGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${ContributionQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// risk and resilence section 1 api
export const RiskSection1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${riskSection1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const RiskSection1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: riskSection1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// risk and resilence section 2 api
export const RiskSection2Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${riskSection2Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const RiskSection2Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: riskSection2Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// risk and resilence section 3 api

export const RiskSection3Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${riskSection3Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const RiskSection3Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: riskSection3Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
// risk and resilence section 4 api

export const RiskSection4Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${riskSection4Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const RiskSection4Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: riskSection4Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const OperationSection1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${operationSection1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: operationSection1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection1SubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: operationSection1SubUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection2Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${operationSection2Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection2Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: operationSection2Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection3Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${operationSection3Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection3Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: operationSection3Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection4Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${operationSection4Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const OperationSection4Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: operationSection4Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// Sources of Funding

export const SourcesOfFundingGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${SourcesOfFundingQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const SourcesOfFundingPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: SourcesOfFundingUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const SourcesOfFundingSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: SourcesOfFundingSubUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Programme Details

export const ProgrammeDetailsGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${ProgrammeDetailsQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ProgrammeDetailsPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: ProgrammeDetailsUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// Programme Details

export const TopDonorsGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${TopDonorsQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const TopDonorsPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: TopDonorsUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const TopDonorsSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: TopDonorsSubUrl,
      method: "POST",
      data: payload,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

// finance apis

export const financeSection1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection2Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection2Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection2Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection2Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection3Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection3Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection3Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection3Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection4Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection4Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection4Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection4Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection5Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection5Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection5Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection5Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection6Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection6Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection6Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection6Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection7Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection7Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection7Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection7Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection8Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection8Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection8Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection8Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection9Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection9Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection9Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection9Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection10Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection10Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection10Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection10Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection11Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${financeSection11Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const financeSection11Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: financeSection11Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const MissionGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${MissionQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const DataPrivacy1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${DataPrivacy1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const DataPrivacy1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: DataPrivacy1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const Capabilities1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Capabilities1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const Capabilities1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Capabilities1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const Challenges1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Challenges1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const Challenges1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Challenges1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const Accountability1Get = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${Accountability1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const Accountability1Post = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: Accountability1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

// compliance

export const ComplianceSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: ComplianceSubUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const InternalComplianceGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${InternalComplianceQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const InternalCompliancePost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: InternalComplianceUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const CompliancePrimaryGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${CompliancePrimaryQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const CompliancePrimaryPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: CompliancePrimaryUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ComplianceIncomeGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${ComplianceIncomeQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ComplianceIncomePost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: ComplianceIncomeUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const ComplianceFCRAGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${ComplianceFCRAQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ComplianceFCRAPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: ComplianceFCRAUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const ComplianceStakeholdersGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${ComplianceStakeholdersQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const ComplianceStakeholdersPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: ComplianceStakeholdersUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const GoverningBodyMemberDetailsGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${GoverningBodyMemberDetails1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const GoverningBodyMemberDetailsPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: GoverningBodyMemberDetails1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const GoverningBodyMemberDetailsSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: GoverningBodyMemberDetailsSub1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const FunctioningOfTheBoardGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${FunctioningOfTheBoard1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const FunctioningOfTheBoardPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: FunctioningOfTheBoard1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const GoodGovernancePracticesGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${GoodGovernancePractices1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const GoodGovernancePracticesPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: GoodGovernancePractices1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const SocialImpactGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${SocialImpact1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const SocialImpactPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: SocialImpact1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const participationInResearch = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${participationInResearcQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const needsAndAskGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${needsAndAsk1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const needsAndAskPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: needsAndAsk1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const PeopleEngageBasedOnNaturePost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: PeopleEngageBasedOnNature1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const PeopleEngageBasedOnNatureSubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: PeopleEngageBasedOnNature1SubUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const PeopleEngageBasedOnNatureGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${PeopleEngageBasedOnNature1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const PeopleEngagedBasedOnDiversityPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: PeopleEngagedBasedOnDiversity1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const PeopleEngagedBasedOnDiversitySubPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: PeopleEngagedBasedOnDiversity1SubUrl,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const PeopleEngagedBasedOnDiversityGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${PeopleEngagedBasedOnDiversity1Q}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const MonthlyCompensationPost = async (payload) => {
  try {
    const { data } = await actionHandler({
      url: MonthlyCompensation1Url,
      method: "POST",
      data: payload,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const MonthlyCompensationGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${MonthlyCompensationQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const WorkshopAttendedGet = async (key) => {
  try {
    const setApplication_no = {
      gsn_no: `${key ? key : ""}`,
    };

    // Convert the args object to a JSON string and encode it for use in a URL
    const args = JSON.stringify(setApplication_no);
    const { data } = await actionHandler({
      url: `${WorkshopAttendedQ}?args=${args}`,
      method: "GET",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
